
import { initializeApp, getApp, getApps } from "firebase/app";
import {
  getAuth,
  setPersistence,
  browserLocalPersistence,
} from "firebase/auth";

// PITICS Creative Tools — Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDyGVPHnTVyWimYSzCpGmMF_RMm1gxhpW4",
  authDomain: "tools.pitics.com",
  projectId: "piticsjgat",
  storageBucket: "piticsjgat.firebasestorage.app",
  messagingSenderId: "898712575285",
  appId: "1:898712575285:web:cc5d6b753ae1597b38807c",
  measurementId: "G-KTDCN5DVS4",
};

// Initialize Firebase only once.
const app = getApps().length > 0
  ? getApp()
  : initializeApp(firebaseConfig);

// Initialize Firebase Authentication.
export const auth = getAuth(app);

// Persist authentication across browser sessions.
export const authPersistenceReady = setPersistence(
  auth,
  browserLocalPersistence
);
